/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  alternatingBackgroundGray: css`
    background-color: var(--cds-color-neutral-background-primary-weak);

    &:nth-of-type(2n) {
      background-color: var(--cds-color-neutral-background-primary);
    }
  `,

  alternatingBackgroundWhite: css`
    background-color: var(--cds-color-neutral-background-primary);

    &:nth-of-type(2n) {
      background-color: var(--cds-color-neutral-background-primary-weak);
    }
  `,
  blueBackground: css`
    background-color: var(--cds-color-emphasis-primary-background-strong);

    &:nth-of-type(2n) {
      background-color: var(--cds-color-emphasis-primary-background-strong);
    }
  `,
};

type Props = {
  sectionId?: string;
  blueBackground?: boolean;
  whiteBackgroundFirst?: boolean;
  children: React.ReactNode;
};

const ModuleContainerStyleWrap = ({ sectionId, blueBackground, whiteBackgroundFirst, children }: Props) => {
  return (
    <section
      css={[
        whiteBackgroundFirst ? styles.alternatingBackgroundWhite : styles.alternatingBackgroundGray,
        blueBackground && styles.blueBackground,
      ]}
      className="rc-ModuleContainerStyleWrap"
      id={sectionId}
    >
      {children}
    </section>
  );
};

export default ModuleContainerStyleWrap;
